import React from 'react';
import { useParams } from 'react-router';
import { PeopleCMSLayout } from '../people.cms.layout';
import { PagePath } from '../../../../navigation/navigation.enums';

export function DepartmentPeopleCMSPage(): JSX.Element {
  const params = useParams();

  return <PeopleCMSLayout path={PagePath.userManagementDepartmentPeople} slugs={{ companySlug: params.companySlug!, departmentSlug: params.departmentSlug! }} type="department" />;
}